import {Toaster} from "sonner";
import {TooltipProvider} from "@/components/ui/tooltip";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import Landing from "@/pages/Landing";
import TermsAndPrivacy from "@/pages/TermsAndPrivacy";
import NotFound from "@/pages/NotFound";
import Voucher from "@/pages/Voucher";

function App() {
    return (
        <TooltipProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Landing/>}/>
                    <Route path="/vop" element={<TermsAndPrivacy/>}/>
                    <Route path="/privacy" element={<Navigate to="/vop" replace/>}/>
                    <Route path="/voucher" element={<Voucher/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </Router>
            <Toaster/>
        </TooltipProvider>
    );
}

export default App;
